import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle,
    Grid,
    TextField,
    Typography,
} from '@mui/material';
import React, { useEffect, useState } from 'react';
import { ERROR_MESSAGES, SUCCESS_MESSAGES } from '../../../configs/messages';
import { ROUTES_LIST } from '../../../helpers/routesList';
import showMessage from '../../../helpers/showMessage';
import { useSnackbar } from 'notistack';
import { sendJsonData } from '../../../helpers/sendJsonData';
import { useParams } from 'react-router';
import { useHistory } from 'react-router-dom';
import { deleteData } from '../../../helpers/deleteData';
import { getDataItem } from '../../../helpers/getDataItem';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import SaveAltIcon from '@mui/icons-material/SaveAlt';
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import Switch from '@mui/material/Switch';
import { sendFormData } from '../../../helpers/sendFormData';

export default function ProgramTypeForm({ isEdit }) {
    const [errors, setErrors] = useState({});
    const [showDeleteValidation, setShowDeleteValidation] = useState(false);
    const [isToggle, setIsToggle] = useState(false)

    const [initialData, setInitialData] = useState({
        name: '',
        active: isToggle,
        imageUrl: '',
        image: null,
    });


    useEffect(() => {
        setIsToggle(initialData.active);
    }, [initialData.active]);

    
    const { enqueueSnackbar } = useSnackbar();
    const history = useHistory();

    const { id } = useParams();

    let submitUrl = 'program-type';
    if (isEdit) {
        submitUrl += `/${id}`;
    }

    useEffect(() => {
        let isActive = true;

        if (!isEdit) {
            return () => (isActive = false);
        }

        // Get data if form type is edit
        getDataItem(submitUrl)
            .then(({ data }) => {
                if (isActive) {
                    delete data.data?.id;

                    setInitialData(data.data);
                    // setInitialData(data);
                }
            })
            .catch((error) => {
                console.error(error);
                showMessage(
                    error.response?.data?.message
                        ? error.response.data.message
                        : ERROR_MESSAGES.REQUEST_FAIL,
                    enqueueSnackbar,
                    'error',
                );
            });

        return () => (isActive = false);
    },[]);

    const validate = () => {
        let tempErrors = { ...errors };
        const requiredMessage = ERROR_MESSAGES.FILL_THE_FIELD;
     tempErrors.name = initialData.name.trim() ? '' : requiredMessage;
        setErrors({
            ...tempErrors,
        });

        return tempErrors;
    };

    const handleInputChange = (e) => {
        const { name, value } = e.target;

        setInitialData({
            ...initialData,
            [name]: value,
        });
    };

    const handleImageInsert = (e) => {
        const uploadedFiles = e.target.files;

        if (uploadedFiles && uploadedFiles.length > 0 && uploadedFiles[0].size > 2097152) {
            showMessage(
                ERROR_MESSAGES.FILE_SIZE_TOO_BIG,
                enqueueSnackbar,
                'error',
            );
            setInitialData({
                ...initialData,
                image: null,
                imageUrl: null,
            });
        } else if (uploadedFiles && uploadedFiles.length > 0) {
            const reader = new FileReader();
            reader.onloadend = () => {
                setInitialData({
                    ...initialData,
                    image: uploadedFiles[0],
                    imageUrl: reader.result,
                });
            };

            reader.readAsDataURL(uploadedFiles[0]);
        }
    };

const handleToggle = () => {
        setIsToggle((prevToggle) => !prevToggle);
        setInitialData({
            ...initialData,
            active: !isToggle,
        });
    };
    const handleSubmit = (e) => {
        e.preventDefault();
        const tempErrors = validate();

        for (const key in tempErrors) {
            if (tempErrors[key]) {
                showMessage(
                    ERROR_MESSAGES.FILL_THE_FORM,
                    enqueueSnackbar,
                    'error',
                );
                return;
            }
        }

        const requestBody = { ...initialData };
        delete requestBody.imgUrl;
        console.log("initial data end bna", initialData)
        sendFormData(requestBody, submitUrl, isEdit)
            .then(() => {
                showMessage(SUCCESS_MESSAGES.ADDED_DATA, enqueueSnackbar);
                history.push(ROUTES_LIST.epgPage);
            })
            .catch((error) => {
                console.error('Error submitting data:', error); // Log the error
                showMessage(
                    error.response?.data?.message
                        ? error.response.data.message
                        : ERROR_MESSAGES.REQUEST_FAIL,
                    enqueueSnackbar,
                    'error',
                );
            });
    };

    const handleDelete = () => {
        deleteData(submitUrl)
            .then(() => {
                showMessage(SUCCESS_MESSAGES.DELETED_DATA, enqueueSnackbar);
                history.push(ROUTES_LIST.programTypeList);
            })
            .catch((error) => {
                console.error(error);
                showMessage(
                    error.response?.data?.message
                        ? error.response.data.message
                        : ERROR_MESSAGES.REQUEST_FAIL,
                    enqueueSnackbar,
                    'error',
                );
            });
    };
 
    return (
        <>
            <form onSubmit={handleSubmit} autoComplete="false">
                <Grid
                    container
                    direction="column"
                    spacing={2}
                    sx={{ width: '100%' }}
                >
                    <Grid
                        item
                        container
                        spacing={2}
                        direction="column"
                        sx={{ width: '100%' }}
                    >
                        <Grid item>
                            <TextField
                                value={initialData.name}
                                variant="standard"
                                label="Нэр"
                                fullWidth
                                name="name"
                                onChange={handleInputChange}
                                error={Boolean(errors.name)}
                                helperText={errors.name}
                            />
                        </Grid>
                        <Grid item container direction="column" gap="20px">
                        <div>
                            {initialData.posterUrl && (
                                <img
                                    src={initialData.posterUrl}
                                    alt="зураг"
                                    style={{
                                        height: '300px',
                                        width: '400px',
                                        objectFit: 'cover',
                                    }}
                                />
                            )}
                        </div>
                        {/* {errors.image ? (
                            <InputErrorMessage errorMessage={errors.image} />
                        ) : null} */}
                        <div>
                            <p style={{ fontSize: '12px' }}>
                                Зургийн харьцаа 4:3 (800x600), зургийн хэмжээ
                                дээд 2mb
                            </p>
                            <Button variant="contained" component="label">
                                <input
                                    hidden
                                    accept="image/*"
                                    type="file"
                                    onChange={handleImageInsert}
                                />
                                Poster зураг оруулах
                            </Button>
                        </div>
                    </Grid>
                        <Grid
                            item
                            container
                            direction="row"
                            justifyContent="space-between"
                        >
                            <Grid item>
                                <Button
                                    variant="contained"
                                    color="warning"
                                    type="button"
                                    onClick={() =>
                                        history.goBack()
                                    }
                                >
                                    <ArrowBackIcon />
                                    <Typography style={{ marginLeft: '10px' }}>
                                        Буцах
                                    </Typography>
                                </Button>
                            </Grid>
                            <Grid item>
                                {/* {isEdit && (
                                    <Button
                                        variant="outlined"
                                        color="error"
                                        type="button"
                                        onClick={() =>
                                            setShowDeleteValidation(true)
                                        }
                                    >
                                        <DeleteOutlineIcon />
                                        <Typography
                                            style={{ marginLeft: '10px' }}
                                        >
                                            Устгах
                                        </Typography>
                                    </Button>
                                )} */}
                                Төлөв <Switch checked={initialData.active} onClick={handleToggle} />

                                <Button
                                    color="success"
                                    style={{ marginLeft: '10px' }}
                                    type="submit"
                                    variant="outlined"
                                >
                                    <SaveAltIcon />
                                    <Typography style={{ marginLeft: '10px' }}>
                                        Хадгалах
                                    </Typography>
                                </Button>
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
            </form>

            {isEdit && (
                <Dialog
                    open={showDeleteValidation}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                >
                    <DialogTitle id="alert-dialog-title">
                        Та энэхүү мэдээллийг устгахыг хүсэж байна уу?
                    </DialogTitle>
                    <DialogContent>
                        <DialogContentText id="alert-dialog-description">
                            Та энэ мэдээллийг устгахыг хүсэж байвал
                            &apos;Тийм&apos; товчийг дарна уу.
                        </DialogContentText>
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={() => setShowDeleteValidation(false)}>
                            Болих
                        </Button>
                        <Button color="error" onClick={handleDelete} autoFocus>
                            Тийм
                        </Button>
                    </DialogActions>
                </Dialog>
            )}
        </>
    );
}
